import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    cartWrapper: InjectableCss;
    registerWrapper: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 8px 32px 8px 16px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 0.8rem;
                    `,
                    css`
                        margin-top: 0.8rem;
                    `,
                    css`
                        margin-top: 0.8rem;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    logoWrapper: {
        css: css`
            text-align: left;
            margin: 8px 16px 8px 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        text-align: center;
                        width: 100%;
                        flex: 0 0 100%;
                    `,
                    css`
                        text-align: center;
                        width: 100%;
                        flex: 0 0 100%;
                    `,
                    css`
                        text-align: center;
                        width: 100%;
                        flex: 0 0 100%;
                    `,
                    null,
                    null,
                ])}
            img {
                height: 56px;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                height: 60px;
                                width: auto;
                                margin: 0;
                            `,
                            css`
                                height: 60px;
                                width: auto;
                                margin: 0;
                            `,
                            css`
                                height: 60px;
                                width: auto;
                                margin: 0;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
        `,
    },
    searchMenuWrapper: {
        css: css`
            width: 70%;
            box-shadow: 0 0 0 1px rgba(204, 204, 204, 1),
            0 1px 0 0 inset rgba(0, 0, 0, 0.1);
            border-radius: 2px;
            background-color: rgba(255, 255, 255, 1);
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    linkListHidden: {
        below: "lg",
    },
    cartWrapper: {
        css: css`
            margin-left: 1rem;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    registerWrapper: {
        css: css`
            margin-left: 1rem;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
            ])}
        `,
    }
};

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => (
    <StyledWrapper {...logoLinksSearchStyles.container}>
        <StyledWrapper {...logoLinksSearchStyles.logoWrapper}>
            <Zone contentId={id} zoneName="Content" />
        </StyledWrapper>
        <StyledWrapper {...logoLinksSearchStyles.searchMenuWrapper}>
            <Zone contentId={id} zoneName="Search" fixed />
        </StyledWrapper>
        <StyledWrapper {...logoLinksSearchStyles.registerWrapper}>
            <Zone contentId={id} zoneName="Register"/>
        </StyledWrapper>
        <StyledWrapper {...logoLinksSearchStyles.cartWrapper}>
            <Zone contentId={id} zoneName="Cart" />
        </StyledWrapper>
    </StyledWrapper>
);

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
    },
};

export default logoLinksSearch;
